module.exports = __webpack_public_path__ + "static/media/patentLogo.dddcb318.png";